import {Controller} from "@hotwired/stimulus"

// Opens and closes a <dialog> that asks the user to confirm an action.
export default class extends Controller {
    static targets = ["dialog"]

    open() {
        this.dialogTarget.showModal()
    }

    close() {
        this.dialogTarget.close()
    }
}
